import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { DealerVehicleResultsRoute } from "../../../navigation/DealerRoutes";
import { useRouteParams } from "../../../navigation/useRouteParams";
import { useGetDealerGroupDealerList } from "../../../queries/useGetDealerGroupDealerList";
import { useGetSecurityToken } from "../../../queries/useGetSecurityToken";
import { useSearchForm } from "../../../stores/hooks/useSearchForm";
import { ComboBox } from "../../../ui/ComboBox/ComboBox";
import { Input } from "../../../ui/Input/Input";
import { Spinner } from "../../../ui/Spinner";
import { ChevronRightIcon } from "../../../ui/icons/ChevronRightIcon";
import { LocationPinIcon } from "../../../ui/icons/LocationPinLightIcon";
import { usePlacement } from "./usePlacement";

export const DealerInput: FunctionComponent = () => {
  const { t } = useTranslation();
  const [, { setDealership }] = useSearchForm();
  const params = useRouteParams(DealerVehicleResultsRoute);
  const {
    data,
    isLoading: dealersLoading,
    selectedDealer,
  } = useGetDealerGroupDealerList();
  const options = data?.map((data) => ({
    data,
    label: data.dealerName,
    value: data.dealerId,
  }));

  const { get, isLoading: tokenLoading } = useGetSecurityToken();

  return (
    <ComboBox
      onSelectOption={async (option): Promise<void> => {
        if (option) {
          await get(option.value);
          setDealership(option.data);
        }
      }}
      id="dealer-combo"
      key={params?.productType}
      options={options || []}
      placement={usePlacement()}
    >
      <Input
        after={
          dealersLoading || tokenLoading ? <Spinner /> : <ChevronRightIcon />
        }
        aria-label="selectedDealer"
        before={<LocationPinIcon />}
        disabled={!data}
        name="product-type"
        placeholder={t("searchForm.selectLocation")}
        readOnly={!data}
        value={selectedDealer?.dealerName || ""}
      />
    </ComboBox>
  );
};
